import { api } from "api";
import Swal from 'sweetalert2';
const url = 'referent_categories';
import { push } from 'react-router-redux';
import { goBack } from 'react-router-redux';
import { initialize as initializeForm } from 'redux-form';
import { createActions, handleActions } from 'redux-actions';

const LOADER_REFERENT_CATEGORY = 'LOADER_REFERENT_CATEGORY';
const SET_DATA_REFERENT_CATEGORY = 'SET_DATA_REFERENT_CATEGORY';
const SET_PAGE_REFERENT_CATEGORY = 'SET_PAGE_REFERENT_CATEGORY';
const SET_UPDATE_DATA_REFERENT_CATEGORY ='SET_UPDATE_DATA_REFERENT_CATEGORY';
const SET_BUSCADOR_REFERENT_CATEGORY = 'SET_BUSCADOR_REFERENT_CATEGORY';
const SET_FILTRO_REFERENT_CATEGORY = 'SET_FILTRO_REFERENT_CATEGORY';

const listar = (page = 1) =>  (dispatch, getStore) => {
    dispatch({type: LOADER_REFERENT_CATEGORY, cargando: true});
    const store = getStore();
    const search = store.referentCategory.buscador;
    const filtro = store.referentCategory.filtro_referentCategory;
    let params = {page, search};

    if(filtro){
        params[''] = filtro
    }
    api.get(`${url}`, params).catch((error) => {
        dispatch({type: LOADER_REFERENT_CATEGORY, cargando: false});
        Swal(
            'Error',
            error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if(data){
            dispatch({type: SET_DATA_REFERENT_CATEGORY, data});
            dispatch({type: SET_PAGE_REFERENT_CATEGORY, page});
        }
        dispatch({type: LOADER_REFERENT_CATEGORY, cargando: false});
    })
};

const detail = id => (dispatch, getState) =>{
    dispatch({type: LOADER_REFERENT_CATEGORY, cargando: true});
    api.get(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_REFERENT_CATEGORY, cargando: false});
        if(error.statusCode  === 404){
            dispatch(push('/referent-category'))
        }
    }).then((data) => {
        dispatch({type: LOADER_REFERENT_CATEGORY, cargando: false});
        if(data){
            if(data.financial_entity != null){
                const financial_entity = {value: data.financial_entity.id, label: data.financial_entity.usuario_fel};
                data.financial_entity = financial_entity;
            }

            const issue_receipt = data.issue_receipt ? "true" : "false";
            data.issue_receipt = issue_receipt;

            dispatch({type: SET_UPDATE_DATA_REFERENT_CATEGORY, updateData: data});
            dispatch(initializeForm('referentCategory', data))
        }
    })
}

const create = () => (dispatch, getStore) => {
    const formData = getStore().form.referentCategory.values;
    const pk = formData.financial_entity.value;
    formData.financial_entity = pk;

    const issue_receipt = formData.issue_receipt === "true" ? true : false;
    formData.issue_receipt = issue_receipt;

    dispatch({type: LOADER_REFERENT_CATEGORY, cargando: true})
    api.post(`${url}`, formData).then((data) => {
        dispatch({type: LOADER_REFERENT_CATEGORY, cargando: false})
        Swal('Éxito', 'Se ha creado la categoría.', 'success')
        .then(() => {
            dispatch(push('/referent-categories'))
        })
    }).catch((error) => {
        dispatch({type: LOADER_REFERENT_CATEGORY, cargando: false})
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).finally(() => {
        dispatch({type: LOADER_REFERENT_CATEGORY, cargando: false})
    });
};

const update = () => (dispatch, getStore) => {
    const formData = _.cloneDeep(getStore().form.referentCategory.values);
    const pk = formData.financial_entity.value;


    formData.financial_entity = pk;

    const issue_receipt = formData.issue_receipt === "true" ? true : false;
    formData.issue_receipt = issue_receipt;

    dispatch({type: LOADER_REFERENT_CATEGORY, cargando: true});
    api.put(`${url}/${formData.id}`, formData)
    .then((data) => {
        dispatch({type: LOADER_REFERENT_CATEGORY, cargando: false});
        if(data){
            Swal(
                'Éxito',
                'Datos editados correctamente.',
                'success'
            ).then(() => {
                dispatch(push('/referent-categories'));
            })
        }
    })
    .catch((error) =>{
        dispatch({type: LOADER_REFERENT_CATEGORY, cargando: false});
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, verifique los datos.',
            'error'
        )
        if(error.statusCode === 404){
            dispatch(push('/referent-category'));
        }
    })
}
const destroy = (id) => (dispatch, getStore) => {
    dispatch({type: LOADER_REFERENT_CATEGORY, cargando: true});
    api.eliminar(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_REFERENT_CATEGORY, cargando: false});
        Swal('Error', 'No se ha logrado borrar el registro.', 'error')
            .then(() => {
                dispatch(listar(1));
        })
    }).then((data) => {
        dispatch({type: LOADER_REFERENT_CATEGORY, cargando: false});
        Swal('Éxito', 'Se ha eliminado correctamente.', 'success')
            .then(() => {
                dispatch(listar(1));
            })
    })
}

const search = (search) => (dispatch, getStore) => {
    dispatch({type: SET_BUSCADOR_REFERENT_CATEGORY, buscador: search});
    dispatch(listar(1));
};
const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FILTRO_REFERENT_CATEGORY, filtro_referentCategory: filtro});
    dispatch(listar(1));
};
export const actions = {
    listar,
    detail,
    create,
    update,
    destroy,
    search,
    filtro
};
export const reducer = {
    [LOADER_REFERENT_CATEGORY]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_REFERENT_CATEGORY]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_REFERENT_CATEGORY]: (state, { page }) => {
        return {...state, page }
    },
    [SET_UPDATE_DATA_REFERENT_CATEGORY]: (state, { updateData }) => {
        return {...state, updateData }
    },
    [SET_BUSCADOR_REFERENT_CATEGORY]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_REFERENT_CATEGORY]: (state, { filtro_referentCategory }) => {
        return {...state, filtro_referentCategory }
    },
}
export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',
    filtro_referentCategory: null,
    updateData: {},
};
export default handleActions(reducer, initialState)
